import { useState } from 'react'
import { Toast } from 'react-vant'
import type { KycFormData } from './useKycForm'

export const useKycFileUpload = (
  _formData: KycFormData,
  setFormData: React.Dispatch<React.SetStateAction<KycFormData>>
) => {
  // 文件状态管理
  const [passportFile, setPassportFile] = useState<File | null>(null)
  const [idCardFrontFile, setIdCardFrontFile] = useState<File | null>(null)
  const [idCardBackFile, setIdCardBackFile] = useState<File | null>(null)
  const [idCardHandHoldFile, setIdCardHandHoldFile] = useState<File | null>(null)

  // 处理图片删除
  const handleImageRemove = (field: string) => {
    console.log('handleImageRemove called:', field)

    // 根据字段类型清除对应的数据
    if (field === 'passport') {
      setFormData(prev => {
        const newData = { ...prev, passport: '' }
        console.log('Cleared passport formData:', newData)
        return newData
      })
      setPassportFile(null)
    } else if (field.startsWith('id_card.')) {
      const subField = field.split('.')[1]
      console.log('Clearing id_card field:', subField)

      setFormData(prev => {
        const newData = {
          ...prev,
          id_card: { ...prev.id_card, [subField]: '' }
        }
        console.log('Cleared id_card formData:', newData)
        return newData
      })

      // 清除对应的文件状态
      switch (subField) {
        case 'front':
          setIdCardFrontFile(null)
          break
        case 'back':
          setIdCardBackFile(null)
          break
        case 'hand_hold':
          setIdCardHandHoldFile(null)
          break
      }
    }
  }

  // 处理图片上传
  const handleImageUpload = (field: string, fileUrl: string, file: File) => {
    console.log('handleImageUpload called:', { field, fileUrl, fileName: file.name })

    // 根据字段类型更新对应的数据
    if (field === 'passport') {
      setFormData(prev => {
        const newData = { ...prev, passport: fileUrl }
        console.log('Updated passport formData:', newData)
        return newData
      })
      setPassportFile(file)
    } else if (field.startsWith('id_card.')) {
      const subField = field.split('.')[1]
      console.log('Updating id_card field:', subField, 'with value:', fileUrl)

      setFormData(prev => {
        const newData = {
          ...prev,
          id_card: { ...prev.id_card, [subField]: fileUrl }
        }
        console.log('Updated id_card formData:', newData)
        return newData
      })

      // 更新对应的文件状态
      switch (subField) {
        case 'front':
          setIdCardFrontFile(file)
          break
        case 'back':
          setIdCardBackFile(file)
          break
        case 'hand_hold':
          setIdCardHandHoldFile(file)
          break
      }
    }
  }

  // 处理图片上传错误
  const handleImageUploadError = (error: string) => {
    Toast.fail({
      position: 'top',
      message: error,
    })
  }

  return {
    // 文件状态
    passportFile,
    idCardFrontFile,
    idCardBackFile,
    idCardHandHoldFile,
    // 文件状态设置函数
    setPassportFile,
    setIdCardFrontFile,
    setIdCardBackFile,
    setIdCardHandHoldFile,
    // 处理函数
    handleImageRemove,
    handleImageUpload,
    handleImageUploadError
  }
}